import React, { useEffect, useRef, useState } from "react";
import MarketDataCard from "./stock-data-card";
import { fetchSeries, selectChosenMarketData, selectCurrentValue, selectMarketData, selectMarketDataComingSoon, selectPeriod, selectStatus, setSelectedMarketData } from "./stock-data-slice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { selectAccessToken } from "../../authentication/authentication-slice";
import { Tooltip } from "react-tooltip";
import { FormatValue } from "../../../app/utils";


const MarketDataSelection: React.FC = () => {

  // React States
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedDivId, setSelectedDivId] = useState("");
  const [translateX, setTranslateX] = useState(0);
  const [translateY, setTranslateY] = useState(0);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  // Redux data
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector(selectAccessToken);
  const period = useAppSelector(selectPeriod);
  const marketDataList = useAppSelector(selectMarketData);
  const marketDataComingSoon = useAppSelector(selectMarketDataComingSoon);
  const chosenMarketData = useAppSelector(selectChosenMarketData);
  const currentValues = useAppSelector(selectCurrentValue);
  const status = useAppSelector(selectStatus);

  // Calculate translate values, when selected market data changes
  useEffect(() => {
    setWidth(document.getElementById(selectedDivId)?.offsetWidth ?? 0);
    setHeight(document.getElementById(selectedDivId)?.offsetHeight ?? 0);
    setTranslateX(document.getElementById(selectedDivId)?.offsetLeft ?? 0);
    setTranslateY(document.getElementById(selectedDivId)?.offsetTop ?? 0);
    if (accessToken) {
      dispatch(fetchSeries({ accessToken, marketData: chosenMarketData, period }));
    }
  }, [selectedDivId])

  // Force a calculation for translate values once for the first market data, when market data list changes
  useEffect(() => {
    if (marketDataList.length > 0) {
      setSelectedDivId(`${marketDataList[0]}_idx_0`);
    }
  }, [marketDataList])

  const changeMarketDataHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, divId: string, index: number) => {
    if (chosenMarketData !== marketDataList[index]) {
      setSelectedIndex(index);
      setSelectedDivId(divId);
      dispatch(setSelectedMarketData({ selected: marketDataList[index] }));
    }
  }

  return (
    <div className="relative">
      <div className={`absolute left-0 top-0 border bg-slate-900/80 border-blue-100/40 shadow-md shadow-slate-900/80 rounded-lg transition-transform duration-300`}
        style={{
          width,
          height,
          transform: `translateX(${translateX}px) translateY(${translateY}px)`,
        }}>
      </div>
      <div className="grid grid-cols-3 lg:grid-cols-5 gap-2 w-full h-full">
        {marketDataList && marketDataList.map((marketData, index) => {
          const divId = `${marketData}_idx_${index.toString()}`;
          return (
            <div
              key={marketData + index.toString()}
              className="relative ml-2"
              id={divId}
            >
              {/** div used for loading time UX improvement (glow when the current market data fetch is pending, disable clicking when some other market data fetch is pending) */}
              <div className={`absolute z-50 top-0 left-0 w-full h-full rounded-lg
                ${status[marketData] === "pending" ? "animate-loading-bg"
                  : Object.values(status).some(s => s === "pending") ? ""
                    : "hidden"}`}>
              </div>

              <div className="cursor-pointer"
                onClick={(e) => !marketDataComingSoon.some(comingSoon => marketData === comingSoon) && changeMarketDataHandler(e, divId, index)}
              >
                <div data-tooltip-id={marketData}>
                  <MarketDataCard selected={selectedIndex === index} marketData={marketData} value={FormatValue(currentValues[marketData], marketData === "Earnings Yield" ? "percentage" : "decimal")} />
                </div>
                {marketDataComingSoon.some(comingSoon => marketData === comingSoon) &&
                  <Tooltip place="bottom" id={marketData} style={{ backgroundColor: "rgba(0, 0, 0, 0.95)", zIndex: 50 }} >
                    <div className="flex flex-col items-center justify-center text-xs lg:text-sm font-semibold text-neutral-300">
                      <label>Em breve</label>
                    </div>
                  </Tooltip>
                }
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default MarketDataSelection;